import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    // eslint-disable-next-line func-names
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      // eslint-disable-next-line eqeqeq
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        // Note: THE METHOD CANNOT CONTAIN ARGUMENTS
        vnode.context[binding.expression](event);
      }
    };
    setTimeout(() => {
      document.body.addEventListener('click', el.clickOutsideEvent);
    }, 100);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
